import { Form as iForm, FormItem as iFormItem } from 'iview'
import Vue from 'vue'
import emitter from '@/util/mixin/emitter'
import AsyncValidator from 'async-validator';

//https://github.com/vuejs/vue/blob/dev/src/core/vdom/vnode.js

/*
  constructor (
    tag?: string,
    data?: VNodeData,
    children?: ?Array<VNode>,
    text?: string,
    elm?: Node,
    context?: Component,
    componentOptions?: VNodeComponentOptions
  ) 
*/
// 中间 formitem remove 经过diff 后，删除了尾部的formitem，

const deepClone = (h , vnode , value) => {

  const vnodeData = vnode.data

  let props = {} , listeners = {} , tag = vnode.tag
  if( !tag ) return vnode.text
  if(vnode.componentOptions){
    if(vnode.componentOptions.propsData){
      props = vnode.componentOptions.propsData
    }
  }

  props.value = value

  vnodeData.props = props

  const cloned = h(tag, vnodeData, vnode.children);
  
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions

  cloned.text = vnode.text;
  cloned.componentOptions = vnode.componentOptions;
  cloned.elm = vnode.elm;
  cloned.context = vnode.context;

  return cloned;
}

const isDecorator = (vnode , prop) => {
  return vnode.data && vnode.data.directives && vnode.data.directives.find(i => i.name == "decorator" && i.value.length > 0 && i.value[0] == prop)
}

const replaceNode = (h , vnodes , value , prop) => {

  for(let i = 0 ; i < vnodes.length ; i++ ){
    let vnode = vnodes[i]
    if(isDecorator(vnode, prop)){
      vnodes[i] = deepClone(h , vnode , value)
      return vnodes
    }else{
      let componentOptions = vnode.componentOptions
      let children = vnode.children
      if(!children && componentOptions) {
        children = componentOptions.children
      }
      if(children && children.length){
        replaceNode(h , children , value , prop)
      }
    }
  }

  return vnodes
}

const cloneValue = (obj) => {
  let type = typeof obj
  if( type == 'number' || type == 'string' || type == 'boolean' || type === undefined || type === null ){
    return obj
  }

  if (obj instanceof Date) {
    var copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  if (obj instanceof Array) {
    return obj.map(i => cloneValue(i))
  }

  if (obj instanceof Object) {
    let copy = {};
    for (let attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = cloneValue(obj[attr])
    }
    return copy
  }

  return obj
}

const dispatch = (node , ...data) => {
  let parent = node.$parent
  while(parent){
    parent.$emit(...data)
    parent = parent.$parent
  }
}
const getFormItemParent = (vnode) => {
  let parent = vnode.componentInstance.$parent
  while($parent){
    return $parent
  }
}

const getComponentDecorator = (component) => {
  if(
    component.$vnode && 
    component.$vnode.data && 
    component.$vnode.data.directives
  ){
    let directive = component.$vnode.data.directives.find(i => i.name == "decorator")
    if(directive){
      return directive.value[0]
    }
  }

  return null
}

const getChildDecorator = (component) => {
  if(component.data && component.data.directives && component.data.directives.find(i => i.name == "decorator")){
    let hit = component.data.directives.find(i => i.name == "decorator")
    return hit.value[0]
  }else{
    const componentOptions = component.componentOptions
    var children = componentOptions.children
    if( children ){
      for(let i = 0 ; i<children.length;i++ ){
        let c = children[i] , res = null
        if( c.data && c.data.directives ){
          let hit = c.data.directives.find(i => i.name == "decorator")
          //console.log('>hit',hit)
          if( hit ){
            return hit.value[0]
          }
        }
        if( c.componentOptions && c.componentOptions.children ){
          res = getChildDecorator(c)
        }

        if(res){
          return res
        }
      }
    }
    return null
  }
  
}

Vue.directive('decorator', {
  bind: (el, binding, vnode) => {
    // console.log('>>>bind',binding)
    dispatch(vnode.componentInstance, 'field-bind', { value: binding.value, instance: vnode.componentInstance })
  },
  update: (el, binding, vnode) => {
    // const parent = vnode.componentInstance.$parent
    dispatch(vnode.componentInstance, 'field-bind', { value: binding.value, instance: vnode.componentInstance })
  },
  unbind:(el,binding, vnode) => {
    // console.log('unbind' , vnode, binding.value)
  }
})


export const Form = {
  name: 'Form',
  extends: iForm,
  data() {
    return {
      fieldValue:{}
    }
  },

  props:{
    form:null
  },
  created(){
   
    this.$on('form-item-create', (field) => {
      let prop = field.prop
      let idx = this.fields.findIndex( i => i.prop == prop )
      if( idx >= 0 ){
        this.fields[idx] = field
      }else{
        this.fields.push(field);
      }
      return false;
    });
    this.$on('form-item-remove', (field) => {
      console.log('remove>>>',field.prop)
      let prop = field.prop
      let idx = this.fields.findIndex( i => i.prop == prop )
      if( idx >= 0 ){
        this.fields.splice(idx , 1)
      }
      return false;
    });

  },
  methods: {
    _setValue(prop , value){
      // console.log('save',prop,value)
      this.fieldValue[prop] = value
    },
    _getValue(prop){
      return this.fieldValue[prop]
    },
    getFieldsValue(){
      let values = {}
      this.fields.forEach(field => {
        values[field.prop] = field.value
      })
      return values
    },
    getFieldValue(prop){
      let hit = this.fields.find(i => i.prop == prop )
      if( hit ){
        return hit.value
      }else{
        return undefined
      }
    },
    validateFields(...rest) {
      console.log(this.fields,'<<<')
      let callback , fieldsKey;
      if(rest.length == 2){
        callback = rest[1]
        fieldsKey = rest[0]
      }else if(rest.length == 1){
        if( typeof rest[0] == 'function'){
          callback = rest[0]
        }else{
          fieldsKey = rest[0]
        }
      }

      let fields = fieldsKey ? this.fields.filter(i => fieldsKey.includes(i.prop)) : this.fields
      return new Promise(resolve => {
        let valid = true;
        let count = 0 , l = fields.length;
        fields.forEach(field => {
          field.validate('', errors => {
            if (errors) {
              valid = false;
            }
            if (++count === l) {
              let publicData = this.getFieldsValue()
              resolve(!valid , publicData);
              if (typeof callback === 'function') {
                callback(!valid, publicData);
              }
            }
          });
        });
      });
    },
    setFieldsValue(data) {
      const fieldValue = {...this.fieldValue}
      this.fieldValue = {...fieldValue,...data}
      this.fields.forEach(field => {
        const prop = field.prop
        if (prop in data){
          // console.log('setField',prop,data[prop])
          field.setField(data[prop])
        }
      })
      //this.validateFields()
    },
    resetFields(data = {}) {
      if (data === null) data = {}
      this.fieldValue = {}
      this.fields.forEach(field => {
        field.resetField(data[field.prop] || null)
      })
    },
    removeField(){
      let idx
    }
  }
}

const slFormItemProps = { ...iFormItem.props }
delete slFormItemProps.prop
delete slFormItemProps.rules

export const FormItem = {
  name: 'FormItem',
  mixins: [emitter],
  props: slFormItemProps,
  data() {
    return {
      prop: null,
      rules: [],
      value: null,
      instance: null,
      _originValue:null,
      prefixCls: 'ivu-form-item',
      isRequired: false,
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
    };
  },
  watch:iFormItem.watch,
  inject: iFormItem.inject,
  computed: {
    ...iFormItem.computed,
    fieldValue(){
      return this.value
    },
  },
  created() {
    this.$on('field-bind', ({ value, instance }) => {
      const prop = value[0]
      let isChange = this.prop && this.prop !== prop

      if (this.prop && this.prop == prop) {

        this.prop = value[0]
        //更新时 只同步rules，其他参数不再同步
        if (value[1]) {
          this.rules = value[1].rules || []
        }
      } 
      else {
        //formitem 移动时，instance 没有发生变化
        if(this.instance && this.instance !== instance){
          this.instance.$off()
        }

        this.instance = instance
        // console.log('new bind ',this.prop,'====>',prop)

        this.prop = prop
        instance.$on(['on-change','change'], (e) => {
          if(this.prop == 'cpId') console.log('instance change' , instance , this.prop)
          //原生事件
          if (e && typeof e == 'object' && e.target) {
            this.setValue(e.target.value)
          } else {
            this.setValue(cloneValue(e))
          }
        })

        let newValue;
        if (value[1]) {
          this.rules = value[1].rules || []
          newValue = value[1].initialValue
          this._originValue = value[1].initialValue
        }

        //属性变换，
        if( isChange ){
          newValue = this.form._getValue(prop)
        }

        this.value = newValue

        this.regProp()
      }
    })
  },
  methods: {
    ...iFormItem.methods,
    //override
    getRules() {
      return this.rules
    },
    setValue(rest){
      //if(this._isDestroyed) return
//      console.log(this.prop , 'set to ',rest)
      this.value = rest
      this.form._setValue(this.prop , rest)
      console.log('reset')
      //console.log('setvalue',this.enableFireChange,this.validateDisabled)
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }
      this.onFieldChange()
      /*if( this.enableFireChange ){
        //this.validateDisabled = false
        this.onFieldChange()
      }else{
        this.enableFireChange = true
      }*/
    },
    resetField() {
      this.setField(this._originValue)
      this.form._setValue(this.prop , this._originValue)

      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = true;

    },
    setField(v) {
      this.value = v
    },
    // new methods
    regProp() {
      this.dispatch('Form', 'form-item-create', this);
      let rules = this.getRules();
      if (rules.length) {
        this.isRequired = rules.some(rule => rule.required)
      }
    },
    unregProp(){
      this.dispatch('Form', 'form-item-remove', this);
      this.prop = null
      this.value = null
      this.isRequired = null
    }
  },
  render(h) {
    const { classes, form, prefixCls, labelFor, labelStyles, contentStyles, $slots, validateState, validateMessage, showMessage , prop , $scopedSlots } = this
    const label = $slots.label || this.label
    const tipEl = (validateState === 'error' && showMessage && form.showMessage) ? <div class={[prefixCls + '-error-tip']}>{ validateMessage }</div> : null
    
    let defaultNode = $slots.default ? $slots.default : []

    if(prop && defaultNode.length){
      defaultNode = replaceNode(h , defaultNode , this.value , prop)
    }

    return (
      <div class={classes}>
          <label class={[prefixCls + '-label']} for={labelFor} style={labelStyles}>{label}</label>
          <div class={[prefixCls + '-content']} style={contentStyles}>
              {defaultNode}
              <transition name="fade">
                {tipEl}
              </transition>
          </div>
      </div>
    )
  },
  beforeDestroy() {
    this.dispatch('Form', 'form-item-remove', this);
    this.prop = null
    this.value = null
    this.isRequired = null
  }
};